export default "__VITE_ASSET__KmlDQ5Jg__"